export function cn(...inputs) {
  const out = [];
  for (const item of inputs) {
    if (!item) continue;
    if (typeof item === "string" || typeof item === "number") {
      out.push(String(item));
    } else if (Array.isArray(item)) {
      const nested = cn(...item);
      if (nested) out.push(nested);
    } else if (typeof item === "object") {
      for (const key of Object.keys(item)) {
        if (item[key]) out.push(key);
      }
    }
  }
  return out.join(" ");
}

export default cn;
